import React from 'react';
import { BookOpenIcon, FingerprintIcon, LockIcon, WifiIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  book: BookOpenIcon,
  lock: LockIcon,
  fingerprint: FingerprintIcon,
  zap: ZapIcon,
  wifi: WifiIcon,
  wrench: WrenchIcon
};
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="border-b border-line bg-canvas" data-id="element-156" data-mp="12i0i0yaa26f">
      <div className="mx-auto max-w-2xl px-3 py-6 text-center sm:px-5" data-id="element-157" data-mp="3t6khdd4bapy2">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.16em] text-accent" data-id="element-158" data-mp="atw4om16jq5w">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1.5 font-display text-base font-extrabold leading-tight text-ink sm:text-xl" data-id="element-159" data-mp="ktmzkotnk76i">
          6 tomos en un solo sistema, creados para aprender desde cero.
        </h2>
        <p className="mt-1.5 font-display text-[0.75rem] font-black uppercase leading-tight text-cyan sm:text-sm" data-id="element-160" data-mp="36cglwrwbsa3t">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-ink-muted" data-id="element-161" data-mp="3fasjjdvm085r">
          No es simplemente otro ebook técnico. Es una ruta de aprendizaje que
          organiza los conocimientos fundamentales para que comprendas qué
          aprender primero, qué viene después y cómo se conecta cada componente
          de un sistema de acceso.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-162" data-mp="2tvp4i2sjaq4">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-line bg-surface p-3 text-left" data-id="element-163" data-mp="6uz5r6snxase" data-mpi={i}>
                <span className="inline-flex w-fit items-center gap-1.5 rounded bg-volt px-2 py-0.5 font-display text-[0.6rem] font-black uppercase tracking-[0.14em] text-ink" data-id="element-164" data-mp="grbvjtl374hv">
                  <Icon size={11} data-id="element-165" data-mp="27zjgoa2axpip" />
                  Tomo {i + 1}
                </span>
                <h3 className="mt-1.5 font-display text-[0.82rem] font-extrabold uppercase leading-tight text-cyan" data-id="element-166" data-mp="2mo78c5911f3d">
                  {tomo.title}
                </h3>
                <p className="mt-1 text-[0.78rem] leading-snug text-ink-muted" data-id="element-167" data-mp="2vmj7wwrvfn7y">
                  {tomo.desc}
                </p>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-3" data-id="element-168" data-mp="35m0c19rh5t1t">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}